var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "843786_whatsapp_icon 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2239 7.55918C29.9422 4.27377 25.5781 2.46367 20.9284 2.46176C11.3481 2.46176 3.55063 10.2586 3.54689 19.8419C3.54555 22.9054 4.34593 25.8956 5.86704 28.5314L3.40112 37.5383L12.6153 35.1213C15.154 36.506 18.0125 37.2359 20.9215 37.2369H20.9286C20.928 37.2369 20.9291 37.2369 20.9286 37.2369C30.508 37.2369 38.306 29.4393 38.3101 19.8558C38.3117 15.2114 36.5055 10.8445 33.2239 7.55918ZM20.9285 34.3015H20.9227C18.3304 34.3005 15.7878 33.6039 13.5697 32.2877L13.0422 31.9747L7.57441 33.4089L9.03392 28.0779L8.69038 27.5312C7.24428 25.2311 6.48052 22.5726 6.48164 19.8429C6.48475 11.8776 12.9657 5.39736 20.9344 5.39736C24.793 5.39856 28.4204 6.9033 31.148 9.634C33.8755 12.3647 35.3768 15.9944 35.3752 19.8546C35.372 27.8205 28.8913 34.3015 20.9285 34.3015Z",
    fill: "#495157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.853 23.4816C28.4187 23.2642 26.2834 22.2137 25.8853 22.0686C25.4873 21.9237 25.1977 21.8512 24.9082 22.286C24.6187 22.7207 23.7864 23.699 23.533 23.9889C23.2797 24.2786 23.0263 24.3151 22.5921 24.0975C22.1578 23.8801 20.7584 23.4216 19.0996 21.942C17.8084 20.7903 16.9369 19.3682 16.6834 18.9333C16.4301 18.4986 16.6565 18.2636 16.8739 18.047C17.0693 17.8523 17.3083 17.5397 17.5254 17.2861C17.7425 17.0326 17.8149 16.8513 17.9597 16.5616C18.1045 16.2717 18.0322 16.0181 17.9235 15.8008C17.8149 15.5834 16.9464 13.4457 16.5845 12.5759C16.2319 11.7292 15.8739 11.8439 15.6072 11.8305C15.3543 11.8178 15.0644 11.8152 14.7749 11.8152C14.4854 11.8152 14.0148 11.9239 13.6168 12.3586C13.2187 12.7935 12.0967 13.8442 12.0967 15.9817C12.0967 18.1195 13.6529 20.1846 13.8701 20.4744C14.0872 20.7644 16.9325 25.151 21.2892 27.0322C22.3254 27.4797 23.1344 27.7469 23.7651 27.947C24.8055 28.2776 25.7523 28.2309 26.5006 28.1191C27.335 27.9944 29.0701 27.0685 29.432 26.0542C29.794 25.0396 29.794 24.1699 29.6853 23.9889C29.5768 23.8077 29.2872 23.699 28.853 23.4816Z",
    fill: "#495157"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.e424aac2a2f29b72e5bcc4e4b2cb2f08.svg";
export { ForwardRef as ReactComponent };